export {};

const HEAD_FIXED_AFTER_Y = 53;

const $window = $(window);
const $head = $('.head');
const $headTop = $('.head__top--mediabank');
const $stub = $('<div class="head-stub"/>');

let lastIsFixed = false;
let lastWidth = innerWidth;

$head.after($stub);

$window
    .on('resize', onResize)
    .on('scroll', onScroll)
;

handle();

function onResize() {
    if (lastWidth !== innerWidth) {
        lastWidth = innerWidth;

        handle();
    }
}

function onScroll() {
    handle();
}

function handle() {
    if ($headTop) {
        if (innerWidth >= NLMK.mediaQueries.mobile.min) {
            const scrollTop = $window.scrollTop();
            const isFixed = scrollTop > HEAD_FIXED_AFTER_Y;

            if (lastIsFixed !== isFixed) {
                lastIsFixed = isFixed;

                $stub.css({
                    height: isFixed ? $head.height() : ''
                });

                $headTop.toggleClass('hidden', isFixed);
                $head.toggleClass('fixed', isFixed);
            }
        } else if (lastIsFixed) {
            lastIsFixed = false;

            $stub.css({
                height: ''
            });

            $headTop.removeClass('hidden');
            $head.removeClass('fixed');
        }
    } else {
        if (innerWidth >= NLMK.mediaQueries.horizontalTablet.min) {
            const scrollTop = $window.scrollTop();
            const isFixed = scrollTop > HEAD_FIXED_AFTER_Y;

            if (lastIsFixed !== isFixed) {
                lastIsFixed = isFixed;

                $stub.css({
                    height: isFixed ? $head.height() : ''
                });

                $head.toggleClass('fixed', isFixed);
            }
        } else if (lastIsFixed) {
            lastIsFixed = false;

            $stub.css({
                height: ''
            });

            $head.removeClass('fixed');
        }
    }
}



// WEBPACK FOOTER //
// ./js/main/module/head/fixed-position.js